import { render } from "./Outstationform.vue?vue&type=template&id=16a8ffa3"
import script from "./Outstationform.vue?vue&type=script&lang=js"
export * from "./Outstationform.vue?vue&type=script&lang=js"

import "./Outstationform.vue?vue&type=style&index=0&id=16a8ffa3&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__